export default function isDescendent(target, ancestor) {
  if (!target.parentElement) return false;

  if (target.parentElement === ancestor) return true;

  return isDescendent(target.parentElement, ancestor);
}
